import React from "react";
import { Button, Glyphicon } from "react-bootstrap";
import RunsheetUpload from "./RunsheetUpload";

const CalendarFooter = () => (
  <div className="footer navbar-fixed-bottom">
    <div style={{ textAlign: "right" }}>
      <div className="display-inline">
        <Button href="/runsheets/new" className="btn btn-default">
          <Glyphicon glyph="plus" /> Add New Runsheet
        </Button>
      </div>{" "}
      <div className="display-inline">
        <RunsheetUpload />
      </div>
    </div>
  </div>
);

export default CalendarFooter;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/CalendarFooter.js